import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full text-start p-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-normal text-sm dark:text-white dark:text-opacity-90 opacity-50" }, " Glisser/déposer un fichier ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["id", "accept"]
const _hoisted_5 = ["for"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dark:text-white dark:text-opacity-90 opacity-50" }, "Importer un fichier", -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "z-10" }, null, -1)
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex justify-end mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaPreview = _resolveComponent("MediaPreview")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalTemplate = _resolveComponent("ModalTemplate")!

  return (_openBlock(), _createBlock(_component_ModalTemplate, {
    openModal: _ctx.openModal,
    title: _ctx.title || 'Sélectionnez une ' + (_ctx.mediaType === 'image' ? 'image' : 'vidéo'),
    onCloseModal: _ctx.restoreLocalData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "w-full h-12 rounded-2xl dark:border-borderWhite dark:text-white dark:text-opacity-90 border border-borderBlackTeazit mt-4 flex justify-center items-center border-opacity-30",
        onDragover: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args)), ["prevent"])),
        onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dragLeave && _ctx.dragLeave(...args)), ["prevent"])),
        onDrop: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.dragPicture($event)), ["prevent"])),
        style: {"min-height":"15rem"}
      }, [
        (!_ctx.src)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.src)
          ? (_openBlock(), _createBlock(_component_MediaPreview, {
              key: 1,
              class: "w-40 h-40",
              "media-type": _ctx.mediaType,
              media: _ctx.src,
              "can-delete": false,
              onPreviewLoaded: _cache[0] || (_cache[0] = (e) => _ctx.onPreviewLoaded(e))
            }, null, 8, ["media-type", "media"]))
          : _createCommentVNode("", true)
      ], 32),
      _createElementVNode("input", {
        type: "file",
        id: _ctx.name + '-media-input-' + _ctx.mediaType,
        accept: (_ctx.mediaType === 'image' ? 'image/jpeg,image/png' : 'video/mp4'),
        style: {"display":"none"},
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputAddPicture($event)))
      }, null, 40, _hoisted_4),
      _createElementVNode("label", {
        class: _normalizeClass(["w-full p-3.5 h-12 dark:border-borderWhite cursor-pointer text-normal transition ease-out duration-700 rounded-2xl flex justify-between items-center mt-4 border border-borderBlackTeazit border-opacity-30", {
        'z-10': !_ctx.hover,
        'z-0': _ctx.hover,
      }]),
        for: _ctx.name + '-media-input-' + _ctx.mediaType
      }, [
        _hoisted_6,
        _createElementVNode("img", {
          class: "w-8",
          for: "fileInputId",
          style: {"opacity":"0.4"},
          src: _ctx.finalFolder,
          alt: ""
        }, null, 8, _hoisted_7)
      ], 10, _hoisted_5),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["absolute z-0 p-4 left-0 top-4 bg-backgroundColorGrayTeazit transition-all text-sm rounded-2xl shadow", {
          'opacity-0': !_ctx.hover,
          'opacity-100': _ctx.hover,
        }])
        }, " - " + _toDisplayString((_ctx.mediaType === 'image' ? 'png, jpg, jpeg' : 'mp4')), 3),
        _createElementVNode("p", {
          onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hover = true)),
          onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hover = false)),
          class: "flex items-center test-normal text-sm mt-2 text-end cursor-pointer dark:text-white dark:text-opacity-90"
        }, [
          _createElementVNode("img", {
            class: "w-3",
            src: _ctx.finalInfo,
            alt: ""
          }, null, 8, _hoisted_10),
          _createTextVNode(" Formats acceptés ")
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          onClick: _ctx.submit,
          disabled: !_ctx.srcPreview
        }, {
          default: _withCtx(() => [
            _createTextVNode("Valider")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["openModal", "title", "onCloseModal"]))
}